import { gql } from '@apollo/client';

export default function generateMultipleEntityDetailsQuery(count) {
    const queryParts = Array.from({ length: count }, (_, i) =>
    `entity${i}: entity(type: $type${i}, id: $id${i}) {
      id
      type
      name
      iconName
      iconType
      iconColor
      primaryClass {
        id
        name
        icon
        iconType
        color
      }
    }`
    ).join('\n');

    const variableDefinitions = Array.from({ length: count }, (_, i) =>
    `$type${i}: String!, $id${i}: ID!`
    ).join(', ');
    
    return gql`
    query multipleEntityDetailsQuery(${variableDefinitions}) {
      ${queryParts}
    }
  `;
}